import { Link, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

import { LinkIcon } from 'src/assets/icons'

import { useStyles } from './../../styles'

interface IProps {
  text: string
  to?: string | null
}

export const TransactionItem = ({ text, to }: IProps) => {
  const classes = useStyles()

  if (!to) {
    return <Typography>{text}</Typography>
  }

  return (
    <Link className={classes.transactionLink} component={RouterLink} to={to} target="_blank">
      {text}
      <LinkIcon className={classes.transactionLinkIcon} />
    </Link>
  )
}
